import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ListModal from "../components/ListModal";
import { showToast } from "../../../utils/showToast";
import { handleListRequest } from "../../../store/services/Store/List";
import {
  addList,
  setActiveList,
  setList,
  setListItems,
  setLists,
} from "../../../store/actions/Store/list";
import { getUserDashboard } from "../../../store/services/Authentication";
export const AddList = ({ selectedStore, isOpen, handleClose }) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userReducer);
  const [listName, setListName] = useState("");
  const [error, setError] = useState("");
  const handleAdd = async (e) => {
    e.preventDefault();
    if (listName) {
      const result = await handleListRequest({
        method: "post",
        url: `users/${user.data.id}/lists`,
        token: user.accessToken,
        data: {
          list_name: listName,
          store_id: selectedStore.id,
        },
      });
      if (result.success) {
        setListName("");
        dispatch(addList(result.data));
        showToast("New List added successfully", "success", true);
        const lists = await getUserDashboard({
          store_id: selectedStore.id,
          user_id: user.data.id,
          token: user.accessToken,
        });
        if (lists.data) {
          dispatch(setLists(lists.data.lists));
        }
        const activeList = lists.data.lists.find(
          (li) => li.list_id === result.data.id
        );
        dispatch(setList(activeList));
        dispatch(setActiveList(activeList));
        dispatch(setListItems(lists.data.listItems));

        handleClose();
      } else {
        setError(result.message);
      }
    }
  };
  const onchangeHandler = (e) => {
    setListName(e.target.value);
    setError("");
  };
  const closeHandler = (e) => {
    handleClose();
  };
  const modalData = {
    title: "Add a new List",
    description: "Give your list a name",
    label: "List Name",
    redButton: "CANCEL",
    purpleButton: "CREATE",
  };
  return (
    <ListModal
      isOpen={isOpen}
      handleClose={handleClose}
      modalData={modalData}
      listName={listName}
      error={error}
      onChangeHandler={onchangeHandler}
      handleAdd={handleAdd}
      closeHandler={closeHandler}
    />
  );
};
